'use client';

import { c as _c } from "react/compiler-runtime";
import { Badge } from '@common/components';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Image } from '@/components/client';
interface CertificateCardProps {
  year: number | null;
  name?: string;
  issuedAt?: string;
  expiredAt?: string;
}
export const CertificateCard = t0 => {
  const $ = _c(35);
  const {
    year,
    name,
    issuedAt,
    expiredAt
  } = t0;
  const [currentDate, setCurrentDate] = useState(_temp);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const interval = setInterval(() => {
        setCurrentDate(dayjs().format("YYYY.MM.DD HH:mm:ss"));
      }, 1000);
      return () => clearInterval(interval);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== name) {
    t3 = {
      label: "\uAE30\uBD80\uC790",
      value: name
    };
    $[2] = name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== issuedAt) {
    t4 = issuedAt && dayjs(issuedAt).format("YYYY.MM.DD");
    $[4] = issuedAt;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = {
      label: "\uBC1C\uAE09\uC77C",
      value: t4
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== expiredAt) {
    t6 = expiredAt && dayjs(expiredAt).format("YYYY.MM.DD");
    $[8] = expiredAt;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = {
      label: "\uB9CC\uB8CC\uC77C",
      value: t6
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      label: "\uC9C0\uC790\uCCB4",
      value: "\uC81C\uC8FC\uD2B9\uBCC4\uC790\uCE58\uB3C4"
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t5 || $[15] !== t7) {
    t9 = [t3, t5, t7, t8];
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const rows = t9;
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <p className="font-600 text-Gray-600 typo-caption2">기부확인증</p>;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== year) {
    t11 = year !== null && <Badge dimensions="H20" className="bg-G-50 text-G-500">{year}년차</Badge>;
    $[18] = year;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <div className="flex min-h-20 items-center justify-between gap-32">{t10}{t11}</div>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p className="w-full text-center font-800 text-Gray-black typo-h4">탐나는 제주패스</p>;
    t14 = <Image src="https://cdn.welfarehello.com/static/jeju-certificate.png" alt={"\uD0D0\uB098\uB294 \uC81C\uC8FC\uD328\uC2A4"} width={350} height={214} className="h-107 w-175" />;
    $[22] = t13;
    $[23] = t14;
  } else {
    t13 = $[22];
    t14 = $[23];
  }
  let t15;
  if ($[24] !== rows) {
    t15 = <div className="flex flex-col items-center gap-24">{t13}{t14}<dl className="flex flex-col gap-4">{rows.map(_temp2)}</dl></div>;
    $[24] = rows;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t12 || $[27] !== t15) {
    t16 = <article className="flex min-h-[24.875rem] w-full flex-col gap-32 rounded-medium bg-Y-25 px-24 py-20 shadow-lg">{t12}{t15}</article>;
    $[26] = t12;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-Gray-700">현재시각</span>;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== currentDate) {
    t18 = <div className="flex items-center gap-8 font-400 typo-caption1">{t17}<span className="tabular-nums text-Gray-black">{currentDate}</span></div>;
    $[30] = currentDate;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t16 || $[33] !== t18) {
    t19 = <div className="flex w-280 flex-col items-center gap-16">{t16}{t18}</div>;
    $[32] = t16;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
};
function _temp() {
  return dayjs().format("YYYY.MM.DD HH:mm:ss");
}
function _temp2(t0) {
  const {
    label,
    value
  } = t0;
  return <div key={label} className="flex items-center gap-8"><dt className="w-60 font-400 text-Gray-700 typo-caption1">{label}</dt><dd className="font-500 text-Gray-black typo-body4">{value || "-"}</dd></div>;
}